import { OnInit } from '@angular/core';
import * as padStart from 'lodash/padStart';
import { Wind } from '../models/wind.model';
var WindComponent = /** @class */ (function () {
    function WindComponent() {
    }
    WindComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(WindComponent.prototype, "direction", {
        /**
         * Returns formatted wind direction (left-padded with zeros)
         */
        get: function () {
            return this.wind.direction ? padStart(this.wind.direction, 3, '0') : null;
        },
        enumerable: true,
        configurable: true
    });
    return WindComponent;
}());
export { WindComponent };
